var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4688 7H10.75C10.4375 7 10.1562 6.84375 10.0312 6.5625C9.9375 6.28125 10 5.9375 10.2188 5.71875L11.5 4.4375C9.53125 2.53125 6.40625 2.53125 4.4375 4.46875C2.5 6.4375 2.5 9.59375 4.4375 11.5625C6.40625 13.5 9.5625 13.5 11.5312 11.5625C11.9062 11.1562 12.5312 11.1562 12.9375 11.5625C13.3125 11.9375 13.3125 12.5625 12.9375 12.9688C10.1875 15.6875 5.78125 15.6875 3.03125 12.9688C0.3125 10.2188 0.3125 5.8125 3.03125 3.0625C5.75 0.34375 10.1562 0.34375 12.9062 3.03125L14.2188 1.71875C14.4062 1.53125 14.75 1.46875 15.0312 1.5625C15.3125 1.6875 15.5 1.96875 15.5 2.25V6.25C15.5 6.6875 15.1562 7 14.75 7H14.4688Z",
    fill: "#6F6F6F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.fc592ca033b3070d18ae77accd13c619.svg";
export { ForwardRef as ReactComponent };